export const MIN_SUPERCOLUMN_WIDTH = 180;
export const MAX_SUPERCOLUMN_WIDTH = 215;
